(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7331],{

/***/ 3834:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/be-part-of-sidr",
      function () {
        return __webpack_require__(8218);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6886);
/* harmony import */ var _styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const SILink = (param)=>{
    let { children , onClick =(e)=>{} , ...props } = param;
    const handleOnClick = (e)=>{
        // @ts-ignore
        onClick(e);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: "".concat((_styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link), " ").concat(props.classes ? props.classes : ""),
        ...props,
        onClick: handleOnClick,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SILink);


/***/ }),

/***/ 8218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ be_part_of_sidr; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/styles/pages/be-part-of-sidr/index.module.scss
var index_module = __webpack_require__(3135);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/link/silink.tsx
var silink = __webpack_require__(5515);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(8116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
;// CONCATENATED MODULE: ./src/config/EncourageBePartSidr.tsx
const EncourageBePartSidr = [
    {
        imageUrl: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_entrepreneurship.webp",
        imageAltText: "sidr entrepreneurship",
        title: "entrepreneurship",
        description: "We encourage an entrepreneurial mindset, where our employees persevere to overcome challenges to be a key element of the SIDR’s success.",
        width: "143.68px",
        height: "221.84px"
    },
    {
        imageUrl: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_diversity.webp",
        imageAltText: "sidr diversity",
        title: "diversity",
        description: "We embrace diversity, in our portfolio, our workforce, and in markets we serve as a driver of sustainable success.",
        width: "290px",
        height: "277px"
    },
    {
        imageUrl: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_leadership.webp",
        imageAltText: "sidr leadership",
        title: "leadership",
        description: "We inspire our employees to reach their full potential in an environment that encourages creativity, knowledge sharing and mutual development, and development opportunities that help shape responsible corporate citizens and future leaders.",
        width: "337.37px",
        height: "190.57px"
    },
    {
        imageUrl: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_integrity.webp",
        imageAltText: "sidr integrity",
        title: "integrity",
        description: "We adhere to the highest standards of ethical business practices and our impeccable and extensive track record is testament to this commitment.",
        width: "175.54px",
        height: "240.7px"
    },
    {
        imageUrl: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_unity.webp",
        imageAltText: "sidr unity",
        title: "unity",
        description: "We are united by a shared vision and work together as one team to deliver stakeholder value.",
        width: "227.62px",
        height: "184.94px"
    }
];
const ImageGallery = [
    {
        imageUrl: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_1.webp",
        imageAltText: "sidr dinner fun"
    },
    {
        imageUrl: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_2.webp",
        imageAltText: "sidr health"
    },
    {
        imageUrl: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_3.webp",
        imageAltText: "sidr love"
    },
    {
        imageUrl: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_4.webp",
        imageAltText: "sidr activity"
    }
];

// EXTERNAL MODULE: ./node_modules/react-simple-typewriter/dist/index.js
var dist = __webpack_require__(2637);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 3 modules
var use_in_view = __webpack_require__(7037);
;// CONCATENATED MODULE: ./src/pages/be-part-of-sidr.tsx










function BePartOfSidr() {
    // these variables are used to animate the left and right image when this view are on screen.
    const ref = (0,react.useRef)(null);
    const isInView = (0,use_in_view/* useInView */.Y)(ref, {
        once: false
    });
    // Configuration for swiper encourage
    const swiperEncourageConfig = {
        modules: [
            swiper_esm/* Navigation */.W_,
            swiper_esm/* Pagination */.tl,
            swiper_esm/* EffectFade */.xW,
            swiper_esm/* Autoplay */.pt
        ],
        spaceBetween: 0,
        initialSlide: 0,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function(index, className) {
                return '<span class="dot swiper-pagination-bullet"><div></div></span>';
            }
        }
    };
    // Configuration for swiper gallery
    const swiperConfigGallery = {
        modules: [
            swiper_esm/* Navigation */.W_,
            swiper_esm/* Pagination */.tl,
            swiper_esm/* EffectFade */.xW
        ],
        spaceBetween: 0,
        centeredSlides: false,
        centeredSlidesBounds: false,
        initialSlide: 0,
        loop: true,
        fade: "true",
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        breakpoints: {
            320: {
                slidesPerView: 2.1,
                spaceBetween: 0
            },
            481: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 0
            },
            1025: {
                slidesPerView: 4,
                spaceBetween: 0
            },
            1201: {
                slidesPerView: 4,
                spaceBetween: 0
            }
        }
    };
    /***
     * This page includes the header and footer components
     * The page contain list of data in that we have image, title, subtitle and description.
     */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (index_module_default()).banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/images/banners/be_part_of_sidr/careerpage_banner_d.webp",
                            alt: "find your"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "context_box",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "find_your",
                                    children: "find your"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "animated_text",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Typewriter */.rf, {
                                        words: [
                                            "calling",
                                            "team",
                                            "future"
                                        ],
                                        loop: true,
                                        typeSpeed: 120,
                                        deleteSpeed: 90,
                                        delaySpeed: 1500
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(silink/* default */.Z, {
                                    classes: "",
                                    href: "/openings",
                                    children: "view open positions"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (index_module_default()).life_at_sidr,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/images/decorations/extra/sidr_logo_golden.svg",
                        alt: "life at sidr"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "title",
                        children: "life at sidr"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "description",
                        children: [
                            "We call ourselves “possibilities” for a reason: we can make happen not just what is possible, but what is impossible. We are collaborating on fresh ideas and new solutions in our engine room of creativity, foresight, and innovation.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "By becoming part of our team at SIDR, you will join other top talents in their fields. These visionary minds and adventurous spirits were drawn by the chance to build and power the communities we serve; the fortune of new opportunity, the breaking of new ground."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (index_module_default()).sidr_encourage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    ...swiperEncourageConfig,
                    speed: 900,
                    slidesPerView: "auto",
                    children: [
                        EncourageBePartSidr.map((encourage, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                className: "container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image_container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: encourage.imageUrl,
                                            alt: encourage.imageAltText,
                                            style: {
                                                height: encourage.height,
                                                width: encourage.width
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "divider_line"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text_container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "title",
                                                children: encourage.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "description",
                                                children: encourage.description
                                            })
                                        ]
                                    })
                                ]
                            }, "encourage-" + index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "swiper-pagination"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (index_module_default()).working_in_sidr,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "title",
                        children: "working in sidr"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "description",
                        children: [
                            "Because of its unprecedented scope, SIDR offers career opportunities in a wide variety of fields, with pursuit of excellence to create the friendly, encouraging workplace culture, enabling our diverse workforce to learn and thrive.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "A job at SIDR is a chance to live in the “brighter future” that we are now developing, an opportunity of unprecedented scope for transformational experiences for people to live happy, healthy, and fun lives. As instilled in the ideals of our values, we are striving to make SIDR a place to rethink innovation and creativity, with leading-edge technology and a thriving business environment."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (index_module_default()).sidr_gallery,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    ...swiperConfigGallery,
                    slidesPerView: "auto",
                    children: [
                        ImageGallery.map((honey, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image_container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        loading: "lazy",
                                        className: "image",
                                        src: honey.imageUrl,
                                        alt: honey.imageAltText
                                    })
                                })
                            }, "gallery-" + index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "swiper-button-prev",
                            tabIndex: 0,
                            role: "button",
                            "aria-label": "Previous slide",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_photo_section_left_arrow.webp",
                                alt: "previous"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "swiper-button-next",
                            tabIndex: 0,
                            role: "button",
                            "aria-label": "Next slide",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_photo_section_right_arrow.webp",
                                alt: "next"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (index_module_default()).sidr_team,
                ref: ref,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "images ".concat(isInView ? "image_animation" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "desktop",
                                src: "/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_left.webp",
                                alt: "image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "desktop",
                                src: "/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_right.webp",
                                alt: "image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "ipad",
                                src: "/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_ipad_left.webp",
                                alt: "image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "ipad",
                                src: "/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_ipad_right%20.webp",
                                alt: "image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "mobile",
                                src: "/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_mobile_left.webp",
                                alt: "image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "mobile",
                                src: "/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_mobile_right.webp",
                                alt: "image"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "find",
                                    children: "find"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "your_team",
                                    children: "your team"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "description",
                                    children: [
                                        "As we travel together, we share a vision, a better world for those around us, improved services, products, understanding and research.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "The work the titans do at SIDR; challenging the tradition. Our strides must be great, yet our footsteps light. Our destination is the journey, traveling wisely, in harmony with the world. Aiming higher and reaching further. "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(silink/* default */.Z, {
                                    classes: "positions",
                                    href: "/openings",
                                    children: "view open positions"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var be_part_of_sidr = (BePartOfSidr);


/***/ }),

/***/ 6886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","link":"link_link__T8hPh","about-image-in":"link_about-image-in__JsJpN","fade-in-honeycomb":"link_fade-in-honeycomb__iJ7y6","dot-falling":"link_dot-falling__xjMoT","dot-falling-before":"link_dot-falling-before__Qz2nK","dot-falling-after":"link_dot-falling-after__fHF3N"};

/***/ }),

/***/ 3135:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","banner":"be-part-of-sidr_banner___5clE","life_at_sidr":"be-part-of-sidr_life_at_sidr__aKKWo","sidr_encourage":"be-part-of-sidr_sidr_encourage__iO6ZQ","working_in_sidr":"be-part-of-sidr_working_in_sidr___NrPY","sidr_gallery":"be-part-of-sidr_sidr_gallery__QX6kF","sidr_team":"be-part-of-sidr_sidr_team__i_Z3C","about-image-in":"be-part-of-sidr_about-image-in__aaWXT","fade-in-honeycomb":"be-part-of-sidr_fade-in-honeycomb__7w5Ol","dot-falling":"be-part-of-sidr_dot-falling__Kmna6","dot-falling-before":"be-part-of-sidr_dot-falling-before__eqFQB","dot-falling-after":"be-part-of-sidr_dot-falling-after__QUZU0"};

/***/ }),

/***/ 2637:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0});var e=__webpack_require__(5893),t=__webpack_require__(7294),r=function(){return r=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},r.apply(this,arguments)};function o(e,t){var o,n;switch(t.type){case"TYPE":return r(r({},e),{speed:t.speed,text:null===(o=t.payload)||void 0===o?void 0:o.substring(0,e.text.length+1)});case"DELAY":return r(r({},e),{speed:t.payload});case"DELETE":return r(r({},e),{speed:t.speed,text:null===(n=t.payload)||void 0===n?void 0:n.substring(0,e.text.length-1)});case"COUNT":return r(r({},e),{count:e.count+1});default:return e}}var n=function(e){var r=e.words,n=void 0===r?["Hello World!","This is","a simple Typewriter"]:r,i=e.loop,s=void 0===i?1:i,u=e.typeSpeed,l=void 0===u?80:u,c=e.deleteSpeed,d=void 0===c?50:c,a=e.delaySpeed,p=void 0===a?1500:a,y=e.onLoopDone,f=e.onType,v=e.onDelete,m=e.onDelay,h=t.useReducer(o,{speed:l,text:"",count:0}),T=h[0],g=T.speed,_=T.text,x=T.count,D=h[1],C=t.useRef(0),E=t.useRef(!1),S=t.useRef(!1),b=t.useRef(!1),k=t.useRef(!1),w=t.useCallback((function(){var e=x%n.length,t=n[e];S.current?(D({type:"DELETE",payload:t,speed:d}),""===_&&(S.current=!1,D({type:"COUNT"}))):(D({type:"TYPE",payload:t,speed:l}),b.current=!0,_===t&&(D({type:"DELAY",payload:p}),b.current=!1,k.current=!0,setTimeout((function(){k.current=!1,S.current=!0}),p),s>0&&(C.current+=1,C.current/n.length===s&&(k.current=!1,E.current=!0)))),b.current&&f&&f(C.current),S.current&&v&&v(),k.current&&m&&m()}),[x,p,d,s,l,n,_,f,v,m]);return t.useEffect((function(){var e=setTimeout(w,g);return E.current&&clearTimeout(e),function(){return clearTimeout(e)}}),[w,g]),t.useEffect((function(){y&&E.current&&y()}),[y]),[_,{isType:b.current,isDelay:k.current,isDelete:S.current,isDone:E.current}]};var i="styles-module_blinkingCursor__yugAC",s="styles-module_blinking__9VXRT";!function(e,t){void 0===t&&(t={});var r=t.insertAt;if(e&&"undefined"!=typeof document){var o=document.head||document.getElementsByTagName("head")[0],n=document.createElement("style");n.type="text/css","top"===r&&o.firstChild?o.insertBefore(n,o.firstChild):o.appendChild(n),n.styleSheet?n.styleSheet.cssText=e:n.appendChild(document.createTextNode(e))}}(".styles-module_blinkingCursor__yugAC{color:inherit;font:inherit;left:3px;line-height:inherit;opacity:1;position:relative;top:0}.styles-module_blinking__9VXRT{animation-duration:.8s;animation-iteration-count:infinite;animation-name:styles-module_blink__rqfaf}@keyframes styles-module_blink__rqfaf{0%{opacity:1}to{opacity:0}}");var u=t.memo((function(t){var o=t.cursorBlinking,n=void 0===o||o,u=t.cursorStyle,l=void 0===u?"|":u,c=t.cursorColor,d=void 0===c?"inherit":c;return e.jsx("span",r({style:{color:d},className:"".concat(i," ").concat(n?s:"")},{children:l}))}));__webpack_unused_export__=u,exports.rf=function(t){var r=t.words,o=void 0===r?["Hello World!","This is","a simple Typewriter"]:r,i=t.loop,s=void 0===i?1:i,l=t.typeSpeed,c=void 0===l?80:l,d=t.deleteSpeed,a=void 0===d?50:d,p=t.delaySpeed,y=void 0===p?1500:p,f=t.cursor,v=void 0!==f&&f,m=t.cursorStyle,h=void 0===m?"|":m,T=t.cursorColor,g=void 0===T?"inherit":T,_=t.cursorBlinking,x=void 0===_||_,D=t.onLoopDone,C=t.onType,E=t.onDelay,S=t.onDelete,b=n({words:o,loop:s,typeSpeed:c,deleteSpeed:a,delaySpeed:y,onLoopDone:D,onType:C,onDelay:E,onDelete:S})[0];return e.jsxs(e.Fragment,{children:[e.jsx("span",{children:b}),v&&e.jsx(u,{cursorStyle:h,cursorColor:g,cursorBlinking:x})]})},__webpack_unused_export__=n;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 7037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useInView; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = document.querySelectorAll(elements));
            elements = selectorCache[elements];
        }
        else {
            elements = document.querySelectorAll(elements);
        }
    }
    else if (elements instanceof Element) {
        elements = [elements];
    }
    /**
     * Return an empty array
     */
    return Array.from(elements || []);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-function.es.js
const isFunction = (value) => typeof value === "function";



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/in-view.es.js



const thresholds = {
    any: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */
    if (typeof IntersectionObserver === "undefined") {
        return () => { };
    }
    const elements = resolveElements(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (isFunction(newOnEnd)) {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs



function useInView(ref, { root, margin, amount, once = false } = {}) {
    const [isInView, setInView] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount: amount === "some" ? "any" : amount,
        };
        return inView(ref.current, onEnter, options);
    }, [root, ref, margin, once]);
    return isInView;
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(3834); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);